/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react"
import { Grid } from "@mui/material"
import { StyledDoneIcon } from "./styles"

export const SelectedMenuItem = ({ data }) => {
  return (
    <React.Fragment>
      <Grid container sx={{ alignItems: "center" }}>
        <Grid item xs={10}>
          {data}
        </Grid>
        <Grid item xs={1}>
          <StyledDoneIcon data-testid="selected-menu-item-tick" />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
